import { usePremiumEssentialsContext } from '@wix/premium-fed-sdk/@premium-essentials';
import { ExperimentSpecs } from '../constants';
export const useIsBmHarmonyThemeEnabled = () => {
  const _ref = usePremiumEssentialsContext(false) ?? {},
    experiments = _ref.experiments;
  return Boolean(experiments == null ? void 0 : experiments[ExperimentSpecs.BmHarmonyTheme]);
};
//# sourceMappingURL=harmonyTheme.js.map